export const HostedFonts = [
    'Roboto',
    'Roboto Slab',
    'Lato',
    'Montserrat',
    'Days One',
    'Raleway',
    'Rowdies',
    'Poppins',
    'Oswald',
    'Open Sans',
];
//# sourceMappingURL=hosted_fonts.js.map